const en = {
  swedish: 'Svenska',
  english: 'English',
  frontPage: {
    heading: 'Front page',
    preamble: 'Choose a municipality in the list below to start the service:',
    loadMunicipalitiesError: 'We are experiencing technical issues, please try again later',
  },
  topMenu: {
    language: 'Språk',
    swedish: 'Svenska',
    english: 'English',
    aboutMunicipality: 'About municipality',
    aboutService: 'About service',
  },
  aboutService: {
    header: 'Välkommen hit',
    subHeader: 'Sweden\'s first digital migration guide',
    sectionMotivation: {
      header: 'Why Välkommen hit?',
      content: 'The purpose of Välkommen hit is to introduce a digitized solution that provides guidance and information to stimulate migration to a location and to provide information to enhance the municipality\'s attractiveness for potential citizens, municipal citizens and establishments. Välkommen hit will help to:',
      ul: ['Places can grow through the migration of new people.', 'Employers get help attracting the required skills through the service.', 'People who used the service consider it good/valuable/desirable.', 'The number of calls and incoming e-mails decreases within and between administrations.'],
    },
    sectionBackground: {
      header: 'Background',
      content: 'Välkommen hit was initiated as a collaboration between nine municipalities in the project eSamverkan where the goal was to increase the population of the municipality and to streamline the migration process. The evolution of digitization focuses on simplifying for citizens and entrepreneurs to manage their contacts with the municipality using modern communication channels. In order to get the fullest possible exchange of the potential of digitization, the internal processes are likely to develop so that they benefit from the new potentials.',
    },
    sectionConnect: {
      header: 'Connect to till Välkommen hit',
      contentP1: 'The service is offered as a Software-as-a-Service (SaaS) and has been developed by Dewire Consultants AB.',
      contentP2: 'To learn more about connecting your municipality, visit us at: ',
      href: 'https://www.dewire.com/valkommen-hit',
    },
    sectionAccessibility: {
      header: 'Accessibility and Consent',
      content: 'The service complies with the following accessibility and consent guidelines:',
      ul: [
        { title: 'GDPR ', href: 'https://www.eugdpr.org/' },
        { title: 'WCAG 2.0 AA ', href: 'https://www.w3.org/TR/WCAG20/' },
        { title: 'Cookies and tracking ', href: 'http://ec.europa.eu/ipg/basics/legal/cookies/index_en.htm' },
      ],
    },
    readMore: 'Read more',
    thirdParty: 'Third party software',
    pageTitle: 'Välkommen hit - About service',
  },
  commutePinModal: {
    header: 'Choose a commute destination',
    contentP1: 'It seems to be your first time using the service, to make your experience better you can choose a commute destination.',
    contentP2: 'This will be used to calculate travel times from each area in the service.',
    contentP3: 'If you do not select a destination, it will use the predetermined one.',
  },
  feedbackModal: {
    title: 'Availability feedback',
    description: 'Vi strävar alltid efter att uppfylla de krav som ställs på att våran webbplats ska vara tillgänglig för alla. Om du upplever att vi inte följer WCAG eller att vi brister i tillgängligheten ser vi gärna att du kontaktar oss och berättar så att vi kan göra tjänsten bättre.',
    messageLabel: 'Message',
    buttonText: 'Submit',
  },
  subscriptionModal: {
    title: 'Subscribe for email information',
    description: 'We can send information about job opportunities or events at your campus. Answer these questions to better tailor the information to your needs',
    name: 'Name',
    mail: 'Mail',
    role: 'Are you a student or do you work?',
    school: 'Where do you study?',
    education: 'What education?',
    year: 'Which year?',
    location: 'Where do you live?',
    roles: {
      STUDENT: 'Student',
      WORKING: 'Employed',
      LOOKING_FOR_WORK: 'Looking for work',
    },
    privacy: {
      description: 'Read and accept our privacy policy',
      accept: 'I accept',
    },
    mailInvalid: 'Requires a valid e-mail address',
    successToast: 'Your question has been submitted',
    failureToast: 'Something went wrong, please try again',
  },
  gdprModal: {
    header: 'GDPR Policy',
    label1: 'Personuppgifter som behandlas',
    p1: 'Namn, E-post, IP-adress, Cookies',
    label2: 'Ändamålet med behandlingen',
    p2: 'Kunna göra riktade informationsutskick till lämplig målgrupp',
    label3: 'Laglig grund för behandlingen',
    p3: 'Samtycke',
    label4: 'Lagringstid',
    p4: '5 år',
    label5: 'Mottagare av personuppgifter',
    label6: 'Övriga upplysningar',
    label7: 'Lämna klagomål på personuppgiftshantering',
    p7: '”Klagomål rörande personuppgiftshanteringen i tjänsten kan lämnas till tillsynsmyndigheten, Datainspektionen. Besök Datainspektionens hemsida (https://www.datainspektionen.se/vagledningar/for-dig-som-privatperson/klagomal-och-tips) för mer information om hur du lämnar klagomål.”',
    p7_2: 'Datainspektionen',
    label8: 'Personuppgiftsansvarig',
  },
  questionModal: {
    title: 'Submit a question',
    description: 'Send us your question and we will answer as soon as we can!',
    name: 'Name',
    mail: 'E-mail address',
    question: 'Question',
    privacy: {
      description: 'Read and accept our privacy policy',
      accept: 'I accept',
    },
    submit: 'Submit',
    mailInvalid: 'Requires a valid e-mail address',
    successToast: 'Your question has been submitted',
    failureToast: 'Something went wrong, please try again',
  },
  municipalityPage: {
    pageTitle: 'Välkommen hit - ',
    aboutMunicipality: 'About municipality',
    aboutService: 'About service',
    language: 'Språk',
    explore: 'Explore',
    start: 'Start',
    information: 'Information',
    moveTo: 'Move to ',
    teacherCallToAction: 'Working as or studying to be a teacher?',
  },
  careerPage: {
    aboutMunicipality: 'About municipality',
    aboutService: 'About service',
    language: 'Språk',
    explore: 'Explore',
    start: 'Start',
    information: 'Information',
    moveTo: 'Move to ',
    registerMail: 'Newsmail',
    submitQuestion: 'Ask us',
  },
  mapView: {
    satellite: 'Satellite',
    map: 'Map',
    areas: 'Areas: ',
    clearFilter: 'Clear filter',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    reload: 'Search again',
  },
  navbar: {
    filter: 'Filter',
    favorites: 'Favorites',
    contact: 'Contact',
    career: 'Career',
  },
  tabSearch: {
    searchArea: 'Search area',
  },
  tabFilter: {
    heading: 'Filter',
    preamble: 'Here you can apply a filter for suggested areas on the map, by selecting the type of accommodation you prefer and how long you want to commute to the selected location.',
    house: 'House',
    apartment: 'Apartment',
    commute: 'Place where you want to commute to:',
    commuteMax: 'Max commute duration',
    showOnMap: 'Show on map',
    showMore: 'Show more…',
    clearFilter: 'Clear filter',
    send: 'Send',
    shareDescription: 'Copy the link below to share your current filter settings.',
  },
  tabCareer: {
    heading: 'Career opportunities in ',
    contentP1: 'Regardless if you are a student looking for that first step in your career or if you have years of experience in your field. Our municipality have opportunities for you!',
    contentP2: 'Check out our career pages for information and a chance to ask questions about work opportunities.',
  },
  tabContact: {
    contact: 'Contact',
    desc: {
      first: 'My name is  ',
      second: ' and I work as a ',
      title: 'municipality guide',
      last: '. Contact me if you have questions or concerns regarding, for example:',
    },
    checklist: {
      housing: 'Living and housing',
      school: 'Schools',
      work: 'Jobs',
      visit: 'Arranging advance visits',
      activities: 'Recreational activities',
      childcare: 'Childcare',
      other: 'Other things that are nice to know before moving here',
    },
    mailBtn: 'Email me',
  },
  tabFavourites: {
    heading: 'My favorites',
    preamble: 'Here you can save your favorite areas and share them with, for example, a companion. You can also compare areas with each other.',
    sortBy: 'Favorites sorted by:',
    vicinity: 'Vicinity',
    compare: 'Compare',
    deselectAll: 'Deselect all',
    selectAll: 'Select all',
    removeSelected: 'Remove selected',
    noFavs: 'You have not saved any favorites yet! \n\n Click on an area on the map and save as favorite.',
    km: 'km',
    toMap: 'Show map',
    sortOptions: 'SORT OPTIONS:',
    asc: 'A-Ö',
    removePrompt: 'Are you sure you want to delete selected areas?',
    sharePreamble: 'Selected areas to share:',
    shareDescription: 'The shareable link shows a comparative overview of selected areas.',
    maxCompare: 'You can only compare 10 favourites at a time. \n \n Unmark favourites and try again.',
    maxShare: 'You can only share 10 favourites at a time. \n \n Unmark favourites and try again.',
  },
  streetView: {
    heading: ' in Google Street View',
    preamble: 'Are you interested in how the area looks like at street level? With Google Street View, you can go around and explore in a virtual representation of the area at your own pace. Take a walk in the area with Google Street View',
  },
  housingListings: {
    noResults: 'There doesn´t seem to be any housing for sale in this area right now.',
    newlyListed: 'Recently listed for sale',
    visit: 'Visist',
    moreForSale: 'to see more homes for sale',
    housingItem: {
      rooms: 'rooms',
      month: 'month',
      plot: 'plot',
      today: 'Today',
      yesterday: 'Yesterday',
      days: 'days',
      detached: 'Detached',
      apartment: 'Apartment',
      farm: 'Farm',
      plotType: 'Plot',
      cottage: 'Cottage',
      semiDetached: 'Semi-detached',
      terraced: 'Terraced',
    },
  },
  areaCarousel: {
    headingMunicipality: 'Explore areas:',
    headingArea: 'More areas to explore:',
  },
  commuteTime: {
    heading: 'Travel time and commute distance',
    preamble: 'Are you wondering how long it takes to commute by bike to a potential workplace? Or maybe how long it takes to walk to a nearby grocery store? Use the box below to find the place you want to commute to see travel times.',
    whereTo: 'Where do you want to commute?',
    toPlaceholder: 'To: ',
    yourResult: 'Your result:',
    fromPlaceholder: 'From: ',
    publicTimeNote: 'Expected travel time when arriving at 8:00 in the morning',
  },
  area: {
    readMore: 'Read more',
    saveArea: 'Save area',
    sendArea: 'Send area',
  },
  common: {
    yes: 'Yes',
    cancel: 'Cancel',
    km: 'km',
    copyLink: 'Copy link',
    share: 'Share',
    close: 'Close',
    next: 'Next',
    prev: 'Previous',
    check: 'Check',
    uncheck: 'Uncheck',
    areaLinks: 'Link collection for areas',
  },
  factBox: {
    pharmacy: 'Distance to pharmacy',
    groceryStore: 'Distance to grocery store',
    hospital: 'Distance to hospital',
    medicalCenter: 'Distance to medical center',
    commuteDestination: 'Distance to',
    averageHouseCost: 'Average house prices',
    averageFlatCost: 'Average apartment prices',
  },
  compare: {
    compareFavs: 'Compare favourites',
    compareFavsPreamble: 'Here you can compare your favourite areas, scroll to the right to see more areas.',
    locationInformation: 'LOCATION INFORMATION',
  },
  changeMunicipalityModal: {
    content: 'You are now leaving the municipality now, do you want to change the municipality?',
  },
};

export default en;



// WEBPACK FOOTER //
// ./src/Resources/en.js